<template>
  <v-card class="elevation-1 mb-4">
    <v-card-title class="d-flex align-center">
      <v-icon color="primary" left>mdi-account-multiple-check</v-icon>
      <span>Students/Employees</span>
      <v-spacer></v-spacer>
      <div class="d-flex align-center">
        <v-chip color="success" class="mr-2">
          <v-icon left small>mdi-check</v-icon>
          {{ matchedCount }} matched
        </v-chip>
        <v-chip color="warning">
          <v-icon left small>mdi-alert</v-icon>
          {{ unmatchedCount }} unmatched
        </v-chip>
      </div>
      <v-btn small text color="primary" @click="$emit('reset')" class="ml-2">
        <v-icon left>mdi-refresh</v-icon>
        Change Files
      </v-btn>
    </v-card-title>

    <v-divider></v-divider>

    <v-container fluid>
      <v-row dense>
        <v-col 
          v-for="item in allItems" 
          :key="item.id" 
          cols="12" sm="6" md="4" lg="3"
        >
          <v-card class="elevation-2">
            <div :class="{'blur-image': !item._matched}">
              <v-img 
                :src="item._previewUrl || placeholderImage" 
                height="200" 
                cover
                class="align-end"
                gradient="to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)"
              >
                <v-card-title class="text-white pa-2">
                  <div>
                    <div class="text-subtitle-1 font-weight-bold">
                      {{ userType === 'Student' ? item.roll_symbol_no : item.contact }}
                    </div>
                    <div class="text-body-2 text-truncate">
                      {{ userType === 'Student' ? item.full_name : item.employee_name }}
                    </div>
                  </div>
                </v-card-title>
              </v-img>
            </div>

            <v-card-actions class="px-3 py-2">
              <v-chip small :color="item._matched ? 'success' : 'warning'">
                <v-icon left small>
                  {{ item._matched ? 'mdi-check' : 'mdi-alert' }}
                </v-icon>
                {{ item._matched ? 'Matched' : 'Unmatched' }}
              </v-chip>
              <v-spacer></v-spacer>
              <span 
                class="text-caption text--secondary"
                v-if="item._matched"
              >
                {{ (item._newImageFile?.size / 1024).toFixed(1) }} KB
              </span>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script setup>
import placeholderImage from "@/assets/images/image_not_available-removebg-preview (1).png"

const props = defineProps({
  allItems: {
    type: Array,
    required: true
  },
  userType: {
    type: String,
    required: true
  },
  matchedCount: {
    type: Number,
    required: true
  },
  unmatchedCount: {
    type: Number,
    required: true
  }
})

defineEmits(['reset'])
</script>

<style scoped>
.blur-image {
  filter: blur(3px);
  transition: filter 0.3s ease;
}

.blur-image:hover {
  filter: blur(0);
}

.text-shadow {
  text-shadow: 1px 1px 3px rgba(0, 0, 0, 0.8);
}
</style>